export default __webpack_public_path__ + "static/media/TS03.a972cca5.png";